import type {
	SpeciesBreedResponse,
	SpeciesBreed,
} from '@/models/consumer-engagement-models'
import type {Result} from '@/utilities/types'
import {http} from '@/services/http'

export const fetchPetBreeds = async (
	species: string,
	locale: string
): Promise<SpeciesBreed[]> => {
	const endpoint = `/api/species/${species}/breeds?locale=${locale}`
	const {data: response} = await http<Result<SpeciesBreedResponse>>(endpoint)

	if (!response.success) {
		throw new Error('Failed to create pet profile')
	}

	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- optional is needed
	return response?.data.data
}
